import { isProjectAdminQuery } from '@common/queries/git';

import { useGraphQlQuery } from '../../data/util';

export const useIsProjectAdmin = (projectId?: string) => {
  const isProjectAdminVariables = { projectId: projectId as string };

  const { data: dataProjectAdmin, isInitialLoading } = useGraphQlQuery(
    ['isProjectAdmin', isProjectAdminVariables],
    isProjectAdminQuery,
    { enabled: !!projectId },
    isProjectAdminVariables
  );
  const isProjectAdmin = Boolean(dataProjectAdmin?.isProjectAdmin);
  return { isProjectAdmin, isInitialLoading };
};
